import ReportedProblemsTable from './ReportedProblemsTable';

export default ReportedProblemsTable;
